import { render } from "./BarraDerecha.vue?vue&type=template&id=03f4061f"
import script from "./BarraDerecha.vue?vue&type=script&lang=js"
export * from "./BarraDerecha.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__